import { z } from 'zod'

export const assistantReasoningEffortSchema = z.enum([
  'none',
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
])
export type AssistantReasoningEffort = z.infer<typeof assistantReasoningEffortSchema>

const reasoning = ['low', 'medium', 'high', 'xhigh', 'max'] as const
const optionalReasoning = ['none', ...reasoning] as const
// Exact IDs from the model documentation. The provider catalogue does not expose capabilities.
const modelReasoning: Readonly<Record<string, readonly AssistantReasoningEffort[]>> = {
  'gpt-6.1-sol': reasoning,
  'gpt-6-astra': reasoning,
  'gpt-6-luna': optionalReasoning,
  'gpt-5.6-terra': optionalReasoning,
}

export const assistantReasoningOptions = (modelId: string): readonly AssistantReasoningEffort[] =>
  modelReasoning[modelId] ?? []

export const assistantReasoningSupported = (
  modelId: string,
  effort: AssistantReasoningEffort | null,
) => effort === null || assistantReasoningOptions(modelId).includes(effort)
